<mat-dialog-content class="popup-container">
    @if (hasDeclined) {
    <ng-container>
        <h2>Accès refusé</h2>
        <div class="popup-text">
            <p>
                Vous avez refusé l'utilisation des cookies essentiels. L'accès à l'application est donc bloqué.
            </p>
            <p>
                Si vous changez d'avis, vous pouvez accepter les cookies pour débloquer l'accès.
            </p>
        </div>
        <div class="popup-actions">
            <button mat-raised-button class="button" (click)="accept()">Accepter les cookies</button>
        </div>
    </ng-container>
    }
    @else {
    <ng-container>
        <h2>Cookies & vie privée</h2>

        <div class="popup-text">
            <p>
                Ce site utilise des cookies afin d’améliorer votre expérience utilisateur.
                En poursuivant votre navigation, vous acceptez notre
                <a href="#" (click)="showPrivacyPolicy($event)">politique de confidentialité</a>.
            </p>
        </div>

        <div class="popup-actions">
            <button mat-stroked-button class="deny-button" (click)="decline()">Refuser</button>
            <button mat-raised-button class="button" (click)="accept()">Accepter</button>
        </div>
    </ng-container>

    @if (showPolicy) {
    <ng-container>
        <h2>Politique de confidentialité</h2>
        <div class="popup-text">
            <p>
                Ce site utilise uniquement des cookies essentiels nécessaires à son bon fonctionnement (ex. : session,
                préférences, sécurité).
            </p>
            <p>
                Aucune donnée personnelle n’est utilisée à des fins publicitaires ou de suivi. Vous pouvez refuser les
                cookies non essentiels à tout moment.
            </p>
            <p>
                Pour en savoir plus, vous pouvez consulter nos mentions légales ou contacter l’administrateur du site.
            </p>
        </div>

        <div class="popup-actions">
            <button mat-raised-button class="button" (click)="hidePrivacyPolicy()">Retour</button>
        </div>
    </ng-container>
    }
    }
</mat-dialog-content>